import { useState } from "react";

const NAV = [
  { label: '今日速递', href: '#trending' },
  { label: '黑料曝光', href: '#featured' },
  { label: '翻车现场', href: '#crash' },
  { label: '塌房合集', href: '#archive' },
  { label: '争议盘点', href: '#debate' },
  { label: '防迷路 FAQ', href: '#faq' },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="relative z-40 border-b border-background-200/80 bg-background-50">
      {/* 顶部订阅条 */}
      <div className="hidden md:block border-b border-background-200/70">
        <div className="mx-auto max-w-6xl px-4 md:px-6 py-2 flex items-center justify-between text-xs text-foreground-600">
          <div className="flex items-center gap-2">
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-radar-line text-primary-500 w-4 h-4 flex items-center justify-center" />
              红黑料 · 负面事件情报速递，每日收录
            </span>
          </div>
          <div className="flex items-center gap-3 whitespace-nowrap">
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-calendar-line w-4 h-4 flex items-center justify-center text-foreground-400" />
              2026 年 9 月 5 日 · 星期六
            </span>
            <span className="hidden lg:inline-flex items-center gap-1.5 rounded-full bg-primary-50 text-primary-700 px-2.5 py-0.5">
              <i className="ri-flashlight-fill w-3.5 h-3.5 flex items-center justify-center" />
              第 0718 期
            </span>
          </div>
        </div>
      </div>

      {/* 报头（杂志刊头） */}
      <div className="border-b border-background-200/70">
        <div className="mx-auto max-w-6xl px-4 md:px-6 py-5 flex flex-col md:flex-row items-center justify-center gap-3 text-center">
          <a href="#top" aria-label="红黑料 首页">
            <h1 className="font-heading leading-none tracking-tight">
              <span className="text-primary-600">红黑</span>
              <span className="text-foreground-950">料</span>
            </h1>
          </a>
          <div className="md:ml-4 md:border-l md:border-background-300/70 md:pl-4 text-foreground-500 font-heading tracking-[0.3em] text-xs uppercase">
            HONHEI&nbsp;·&nbsp;观察
          </div>
        </div>
      </div>

      {/* 分类导航（吸附） */}
      <nav className="sticky top-0 bg-background-50/95 backdrop-blur">
        <div className="mx-auto max-w-6xl px-4 md:px-6">
          <div className="flex items-center justify-between gap-2 md:gap-4">
            <button
              type="button"
              aria-label="打开菜单"
              className="md:hidden flex items-center justify-center w-9 h-9 rounded-md text-foreground-700 hover:bg-background-200 cursor-pointer"
              onClick={() => setOpen((v) => !v)}
            >
              <i className={`${open ? 'ri-close-line' : 'ri-menu-2-line'} text-xl w-6 h-6 flex items-center justify-center`} />
            </button>

            <div className="hidden md:flex items-center gap-1">
              {NAV.map((n) => (
                <a
                  key={n.href}
                  href={n.href}
                  className="whitespace-nowrap px-3 py-2.5 text-sm text-foreground-700 hover:text-primary-600 transition-colors"
                >
                  {n.label}
                </a>
              ))}
            </div>

            <div className="flex items-center gap-2">
              <a
                href="#faq"
                aria-label="检索说明"
                className="flex items-center justify-center w-9 h-9 rounded-md text-foreground-700 hover:bg-background-200 cursor-pointer"
              >
                <i className="ri-search-line text-lg w-5 h-5 flex items-center justify-center" />
              </a>
              <a
                href="#trending"
                className="hidden sm:inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 text-background-50 px-3.5 py-2 text-sm font-medium hover:bg-primary-600 transition-colors"
              >
                看今日热榜
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
              </a>
            </div>
          </div>

          {open && (
            <div className="md:hidden border-t border-background-200/70 py-2">
              {NAV.map((n) => (
                <a
                  key={n.href}
                  href={n.href}
                  onClick={() => setOpen(false)}
                  className="block whitespace-nowrap px-2 py-2.5 text-sm text-foreground-800 hover:text-primary-600"
                >
                  {n.label}
                </a>
              ))}
            </div>
          )}
        </div>
      </nav>
    </header>
  );
}